import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import { IStore } from '../../../../redux/store';
import { ballastSelectors } from '../../../../redux/app/ballast';
import moment from 'moment';
import {
	getFormattedDateTime,
	getItemNumber,
	getPlaceOfBallast,
	getPlaceOfBallastEnd,
} from '../../../../redux/app/marpol/utils';
import {
	TBallastTableLog,
	EBallastRecordCode,
} from '../../../../redux/app/ballast/@types';
import versions from '../../../../redux/app/ballast/versions';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {};
type BallastTankOperationsPrintViewProps = PropsFromRedux & OwnProps;
function BallastTankOperationsPrintView(
	props: BallastTankOperationsPrintViewProps
) {
	const { tableLogs, bwmsInfo } = props;
	let version = versions[1].value;
	if (bwmsInfo?.version) {
		version = bwmsInfo.version;
	}

	return (
		<div className="ws-scroll max-h-[calc(100vh-145px)] print:max-h-full">
			<div className="flex justify-center items-center my-6">
				<div className="bg-white rounded-lg shadow-lg w-full max-w-xl">
					<div className="px-6 py-4 border-b border-gray-200 bg-gray-100">
						<h4 className="text-m font-semibold text-gray-800 text-center">
							Column names mnemonic references
						</h4>
					</div>
					<div className="px-6 py-4">
						<ol className="list-decimal list-inside text-sm space-y-1">
							<li>
								Ref A - Estimated uptake from sea(M³), where
								applicable
							</li>
							<li>
								Ref B - Estimated circulated or treated(M³),
								where applicable
							</li>
							<li>
								Ref C - Estimated discharged into sea(M³), where
								applicable
							</li>
							<li>
								Ref D - Estimated intake from reception
								facility(M³), where applicable
							</li>
							<li>
								Ref E - Estimated discharged to port reception
								facility(M³), where applicable
							</li>
						</ol>
					</div>
				</div>
			</div>
			<table className="wayship-table-light ballast-tanks-operations-table bg-gray-100  print:bg-gray-100 print:border-spacing-[1px] table-fixed w-full">
				<thead>
					<tr className="theader">
						<th className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-24 print:text-[7px] print:min-w-[32px] print:m-0">
							Date
						</th>
						{/* <th>
							<div className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-20 print:text-[7px] print:min-w-[30px] print:m-0">
								Code
							</div>
						</th> */}
						<th className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-20 print:text-[7px] print:min-w-[60px] print:m-0 break-words">
							Start Location/Port
						</th>
						<th className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-20 print:text-[7px] print:min-w-11 print:m-0">
							Time started (UTC)
						</th>
						<th className="m-px text-[9.5px]  font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-20 print:text-[7px] print:min-w-[32px] print:m-0">
							Depth(m)
						</th>
						<th className="m-px text-[9.5px]  font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-20 print:text-[7px] print:min-w-[30px] print:m-0">
							Tank
						</th>
						<th className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-20 print:text-[7px] print:min-w-[32px] print:m-0">
							Initial content (M³)
						</th>
						<th className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-24 print:text-[7px] print:min-w-[32px] print:m-0">
							Ref A
						</th>
						<th className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-24 print:text-[7px] print:min-w-[32px] print:m-0">
							Ref B
						</th>
						<th className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-24 print:text-[7px] print:min-w-[32px] print:m-0">
							Ref C
						</th>
						<th className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-24 print:text-[7px] print:min-w-[32px] print:m-0">
							Ref D
						</th>
						<th className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-24 print:text-[7px] print:min-w-[32px] print:m-0">
							Ref E
						</th>
						<th className="m-px text-[9.5px]  font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-20 print:text-[7px] print:min-w-[32px] print:m-0">
							Final content (M³)
						</th>
						<th className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-20 print:text-[7px] print:min-w-[60px] print:m-0 break-words">
							End Location/Port
						</th>
						<th className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-20 print:text-[7px] print:min-w-11 print:m-0">
							Time completed (UTC)
						</th>
						<th className="m-px text-[9.5px]  font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-28 print:text-[7px] print:min-w-[40px] print:m-0">
							Method Employed
						</th>
						{/* {version !== versions[0].value ? (
                            <>
                                <th>
                                    <div className="m-px text-[9.5px]  font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-28 print:text-[7px] print:min-w-[30px] print:m-0">
                                        Based on BWMP ?
                                    </div>
                                </th>
                                <th>
                                    <div className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-28 print:text-[7px] print:min-w-[32px] print:m-0">
                                        Density
                                    </div>
                                </th>
                                <th>
                                    <div className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-28 print:text-[7px] print:min-w-[40px] print:m-0">
                                        Pumps used
                                    </div>
                                </th>
                                <th>
                                    <div className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-28 print:text-[7px] print:min-w-[40px] print:m-0">
                                        Temps (°C)
                                    </div>
                                </th>
                                <th>
                                    <div className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-28 print:text-[7px] print:min-w-[40px] print:m-0">
                                        Salinity
                                    </div>
                                </th>
                                <th>
                                    <div className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-20 print:text-[7px] print:min-w-[40px] print:m-0">
                                        Origin of Ballast
                                    </div>
                                </th>
                            </>
                        ) : null} */}
						{/* <th>
                            <div className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-20 print:text-[7px] print:min-w-[40px] print:m-0">
                                Transfer to/from
                            </div>
                        </th> */}
						<th className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-20 print:text-[7px] print:min-w-[40px] print:m-0">
							Remarks
						</th>
						{/* {version !== versions[0].value ? (
                            <th>
                                <div className="m-px text-[9.5px] font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300  min-w-20 print:text-[7px]  print:m-0">
                                    Signature
                                </div>
                            </th>
                        ) : null} */}
					</tr>
				</thead>
				<tbody>
					{tableLogs.map((log) => {
						const date = moment(
							log?.selectedDate,
							'YYYY-MM-DD'
						).format('DD-MMM-YYYY');

						const code = getItemNumber(
							// @ts-ignore
							log?.recordCode,
							log?.isBallastWaterTreatmentPlanUsed,
							log?.operationType
						);
						const startTime = getFormattedDateTime(
							log?.startDate,
							log?.startTime,
							version
						);
						const placeOfBallast = getPlaceOfBallast(
							// @ts-ignore
							log?.placeOfBallast
						);

						const placeOfBallastEnd = getPlaceOfBallastEnd(
							// @ts-ignore
							log?.placeOfBallast
						);
						const endTime = getFormattedDateTime(
							log?.endDate,
							log?.endTime,
							version
						);
						const validateAndRenderUptake = (
							log: TBallastTableLog
						) => {
							if (log?.estimatedUptake === undefined) {
								return '--';
							} else if (
								log?.recordCode ===
								EBallastRecordCode.INTERNAL ||
								log?.operationType ===
								'DEBALLAST_TO_RECEPTION_FACILITY_MEPC80'
							) {
								return '--';
							} else {
								return log.estimatedUptake;
							}
						};
						const validateAndRenderDischarge = (
							log: TBallastTableLog
						) => {
							if (log?.estimatedDischarged === undefined) {
								return '--';
							} else if (
								log?.operationType ===
								'DEBALLAST_TO_RECEPTION_FACILITY_MEPC80'
							) {
								return '--';
							} else {
								return log.estimatedDischarged;
							}
						};
						const validateAndRenderReceptionFacilityUptake = (
							log: TBallastTableLog
						) => {
							if (
								log?.operationType ===
								'DEBALLAST_TO_RECEPTION_FACILITY_MEPC80' &&
								log?.estimatedUptake
							) {
								return log.estimatedUptake;
							} else {
								return '--';
							}
						};
						const validateAndRenderReceptionFacilityDischarge = (
							log: TBallastTableLog
						) => {
							if (
								log?.operationType ===
								'DEBALLAST_TO_RECEPTION_FACILITY_MEPC80' &&
								log?.estimatedDischarged
							) {
								return log.estimatedDischarged;
							} else {
								return '--';
							}
						};
						const validateAndRenderCirculatedOrTreated = (
							log: TBallastTableLog
						) => {
							return log.recordCode ===
								EBallastRecordCode.INTERNAL
								? log?.estimatedUptake == undefined
									? '--'
									: log.estimatedUptake
								: log?.estimatedCirculatedOrTreated ===
									undefined
									? '--'
									: log?.estimatedCirculatedOrTreated;
						};
						const validateAndRenderSalinityValue = (
							log: TBallastTableLog
						) => {
							if (log?.salinity && log?.salinityUnits) {
								return `${log.salinity}(${log.salinityUnits})`;
							} else if (log?.salinity) {
								return log.salinity;
							} else {
								return '--';
							}
						};
						const depth = log?.depth;
						const initialVolume = log?.initialVolume;
						const tankNumber = log?.tank?.tankCode;

						return (
							// @ts-ignore
							<tr key={log?._id}>
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[32px]">
										{date}
									</div>
								</td>
								{/* <td className="relative">
                                    <div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[30px]">
                                        {code}
                                    </div>
                                </td> */}
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[32px] break-words">
										{placeOfBallast}
									</div>
								</td>
								<td className="relative">
									<div className=" text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-11">
										{startTime}
									</div>
								</td>
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[32px]">
										{depth}
									</div>
								</td>
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[30px]">
										{tankNumber}
									</div>
								</td>
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[32px]">
										{initialVolume}
									</div>
								</td>
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-11">
										{validateAndRenderUptake(log)}
									</div>
								</td>
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-11">
										{validateAndRenderCirculatedOrTreated(
											log
										)}
									</div>
								</td>
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-11">
										{validateAndRenderDischarge(log)}
									</div>
								</td>
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-11">
										{validateAndRenderReceptionFacilityUptake(
											log
										)}
									</div>
								</td>
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-11">
										{validateAndRenderReceptionFacilityDischarge(
											log
										)}
									</div>
								</td>
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[32px]">
										{log?.finalVolume}
									</div>
								</td>
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[60px] break-words">
										{placeOfBallastEnd}
									</div>
								</td>
								<td className="relative">
									<div className=" text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-11">
										{endTime}
									</div>
								</td>
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[40px]">
										{log?.operationMethod
											? log?.operationMethod
											: '--'}
									</div>
								</td>
								{/* {version !== versions[0].value ? (
                                    <>
                                        <td className="relative">
                                            <div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[30px]">
                                                {log?.isBallastWaterTreatmentPlanUsed
                                                    ? 'YES'
                                                    : 'NO'}
                                            </div>
                                        </td>
                                        <td className="relative">
                                            <div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[40px]">
                                                {log?.density}
                                            </div>
                                        </td>
                                        <td className="relative">
                                            <div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[40px]">
                                                {log?.pumpsUsed === ''
                                                    ? '--'
                                                    : log?.pumpsUsed}
                                            </div>
                                        </td>
                                        <td className="relative">
                                            <div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[40px]">
                                                {log?.temperature}
                                            </div>
                                        </td>
                                        <td className="relative">
                                            <div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:text-[7px] print:min-w-[40px]">
                                                {log?.salinity}
                                            </div>
                                        </td>
                                    </>
                                ) : null} */}
								{/* <td className="relative">
                                    <div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:min-w-[40px]">
                                        {`${
                                            !log?.transferToFrom
                                                ? '--'
                                                : log?.transferToFrom
                                        }`}
                                    </div>
                                </td> */}
								{version !== versions[0].value ? (
									<td className="relative">
										<div className="text-[7.5px] leading-4 font-medium  text-center text-black bg-white print:min-w-[40px]">
											{log.placeOfBallast?.place ===
												'AT_RECEPTION_FACILITY'
												? // @ts-ignore
												log?.placeOfBallast
													?.originOfBallast
												: log?.originOfBallast
													? log?.originOfBallast
													: '--'}
										</div>
									</td>
								) : null}
								<td className="relative">
									<div className="text-[9.5px] leading-4 font-medium  text-center text-black bg-white print:min-w-[40px]">
										{log?.remarks ? log.remarks : '--'}
									</div>
								</td>
								{/* {version !== versions[0].value ? (
                                    <td className="relative">
                                        <div className="text-[9.5px] leading-4 font-medium  text-left text-black bg-white signature print:break-all">
                                            {getSignature(
                                                log?.submittedBy,
                                                // @ts-ignore
                                                log?.approvedBy
                                            )}
                                        </div>
                                    </td>
                                ) : null} */}
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const ballastStore = ballastSelectors._getStore(store);
	const vesselStore = vesselSelectors._getStore(store);
	const tableLogs = ballastSelectors.getTableLogs(ballastStore);
	const bwmsInfo = vesselSelectors.getBallastData(vesselStore);
	return {
		tableLogs,
		bwmsInfo,
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(BallastTankOperationsPrintView);
